import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Grid,
  Alert,
  CircularProgress,
  Chip,
} from "@mui/material";
import { config, KeyUri } from '../key';

const BecomeCoach = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    bio: "",
    experience: "",
    specialization: "",
    image: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Convert comma-separated specialization → array
  const getSpecializationArray = () => {
    return form.specialization
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const payload = {
        ...form,
        specialization: getSpecializationArray(),
      };

      await axios.post(`${KeyUri.BACKEND_URI}/coach/apply`, payload);

      setSuccess("Application submitted successfully!");

      // Reset form
      setForm({
        name: "",
        email: "",
        phone: "",
        bio: "",
        experience: "",
        specialization: "",
        image: "",
      });
    } catch (err) {
      setError(
        err.response?.data?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
  <Box
  sx={{
    maxWidth: 800,
    mx: "auto",
    mt: { xs: 12, md: 20 }, mb: 8
  }}
>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Become a Coach
        </Typography>

        <Typography variant="body2" mb={3}>
          Fill in your details and our team will review your application.
        </Typography>

        {success && <Alert severity="success">{success}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Full Name"
                name="name"
                fullWidth
                required
                value={form.name}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Email"
                name="email"
                type="email"
                fullWidth
                required
                value={form.email}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Phone"
                name="phone"
                fullWidth
                required
                value={form.phone}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Experience (e.g. 5 years)"
                name="experience"
                fullWidth
                required
                value={form.experience}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Specialization (comma separated)"
                name="specialization"
                fullWidth
                placeholder="Yoga, Meditation, Ayurveda"
                value={form.specialization}
                onChange={handleChange}
              />

              {/* Preview chips */}
              <Box mt={1}>
                {getSpecializationArray().map((item, i) => (
                  <Chip key={i} label={item} sx={{ mr: 1, mt: 1 }} />
                ))}
              </Box>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Bio"
                name="bio"
                fullWidth
                required
                multiline
                rows={4}
                value={form.bio}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Profile Image URL"
                name="image"
                fullWidth
                placeholder="Paste image URL"
                value={form.image}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : "Submit Application"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Box>
  );
};

export default BecomeCoach;